import * as React from 'react';
import { useSelector } from 'react-redux';

import { isPrintVersionPhoneVisibilitySelector } from 'shared/selectors/print';

import { BookButtonContainer } from './BookButtonContainer';
import { PhonesContainer } from './PhonesContainer';
import { SendMessageButtonContainer } from './SendMessageButton';
import { NewbuildingContactsContainerLoadable } from '../../components/contacts_aside';
import { isNewbuildingSelector, selectIsOfferPublished, selectCianPartner } from '../../selectors';
import { selectShouldRenderContacts } from '../../selectors/contacts/selectShouldRenderContacts';
import { selectorEntryToShowEnabled } from '../../selectors/contacts/selectorEntryToShowEnabled';
import { OnlineStatusContainer } from '../OnlineStatusContainer';

export const GalleryContactsContainer = () => {
  const shouldRenderContactButtons = useSelector(selectShouldRenderContacts);
  const isPublished = useSelector(selectIsOfferPublished);
  const entryToShowEnabled = useSelector(selectorEntryToShowEnabled);
  const isNewbuilding = useSelector(isNewbuildingSelector);
  const isCianPartner = useSelector(selectCianPartner);
  const isPrintVersion = useSelector(isPrintVersionPhoneVisibilitySelector);

  if (!isPublished || entryToShowEnabled) {
    return null;
  }

  return (
    <>
      {isCianPartner && <BookButtonContainer />}
      {!isCianPartner && isNewbuilding && !isPrintVersion && (
        <NewbuildingContactsContainerLoadable
          contactsButton={<PhonesContainer trackingAction="Open_card_fullscreen_gallery" />}
          callbackPlaceType="gallery"
        />
      )}
      {!isCianPartner && !isNewbuilding && shouldRenderContactButtons && (
        <PhonesContainer trackingAction="Open_card_fullscreen_gallery" />
      )}
      {shouldRenderContactButtons && <SendMessageButtonContainer />}
      <OnlineStatusContainer />
    </>
  );
};
